import React, { useState, useEffect, useCallback } from 'react';
import { Modal, Checkbox, Button } from 'antd';
import './index.scss';

const STORAGE_KEY = 'adobe_change_modal_hidden';

const getModalWidth = () => {
   const w = window.innerWidth;
   if (w <= 768) return '95vw';
   if (w <= 1120) return '90vw';
   return 980;
};

const useModalWidth = () => {
   const [width, setWidth] = useState(getModalWidth);

   useEffect(() => {
      const handleResize = () => setWidth(getModalWidth());
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
   }, []);

   return width;
};

  const ByteBookseClick = () => {
    window.open('https://dtsbytebooks.com/register', '_blank', 'noopener,noreferrer');
  };
const ActionItems = () => (
   <div className='need-to-do'>
      <div>
         <h2 className='red-text'>สิ่งที่คุณต้องดำเนินการก่อนสิ้นเดือนพฤษภาคม 2569</h2>
         <ul>
            <li>
               สมัครบัญชี ByteBooks ได้ที่ <u onClick={ByteBookseClick}>ByteBooks</u>
            </li>
            <li>
               <b>สำคัญ:</b> กรุณาใช้อีเมลเดียวกับที่เคยใช้กับ Adobe ID เพื่อรักษาสิทธิ์การเข้าถึงหนังสือและคลัง eBook
               เดิมของคุณ
            </li>
         </ul>
      </div>

      <div>
         <h2 className='red-text'>หมายเหตุ</h2>
         <ul>
            <li>แอป Adobe Digital Editions (ADE) ยังสามารถใช้งานได้ตามปกติ ไม่จำเป็นต้องถอนการติดตั้ง</li>
            <li>
               หากหน้าล็อกอินยังแสดงคำว่า “Adobe ID” กรุณากรอก ByteBooks ID ได้ตามปกติ ระบบจะยังสามารถทำงานได้ถูกต้อง
            </li>
         </ul>
      </div>
   </div>
);

const AdobeChangeModal = () => {
   const [open, setOpen] = useState(false);
   const [dontShowAgain, setDontShowAgain] = useState(false);
   const modalWidth = useModalWidth();

   useEffect(() => {
      if (!localStorage.getItem(STORAGE_KEY)) {
         setOpen(true);
      }
   }, []);

   const handleClose = useCallback(() => setOpen(false), []);

   const handleOk = useCallback(() => {
      if (dontShowAgain) {
         localStorage.setItem(STORAGE_KEY, 'true');
      }
      setOpen(false);
   }, [dontShowAgain]);

   const footer = (
      <div className='footer'>
         <Checkbox checked={dontShowAgain} onChange={(e) => setDontShowAgain(e.target.checked)}>
            ไม่ต้องแสดงอีก
         </Checkbox>
         <Button type='primary' className='button' size='large' onClick={handleOk}>
            ตกลง
         </Button>
      </div>
   );

   return (
      <Modal
         visible={open}
         width={modalWidth}
         footer={footer}
         closeIcon={<img src='/images/faq/pdpa/CloseIcon.svg' alt='close' className='close-icon' />}
         className='adobe-change-modal'
         style={{ top: 16 }}
         onCancel={handleClose}
      >
         <div className='adobe-change-body-modal'>
            <img src='/images/ebookToDRM.png' alt='ebook to DRM' className='ebook-to-drm-img' />
            <div className='important-announcement'>
               <h1>ประกาศสำคัญ: การเปลี่ยนแปลงการเข้าสู่ระบบ Adobe eBook และ Adobe DRM</h1>
               <p>
                  Adobe ได้ถ่ายโอนธุรกิจและการดูแลระบบ Adobe eBook Platform Components ไปยัง{' '}
                  <b>Wipro Engineering – Connected Services</b> <br /> ภายใต้บริการ ByteBooks
                  โดยการเปลี่ยนแปลงนี้จะมีผลตั้งแต่วันที่ 23 มิถุนายน 2569 เป็นต้นไป หลังจากวันดังกล่าว
                  <br />
                  ผู้ใช้งานจะไม่สามารถใช้ Adobe ID สำหรับเข้าสู่ระบบ Adobe Digital Editions (ADE) ได้อีกต่อไป
                  และจำเป็นต้องเปลี่ยนมาใช้ ByteBooks ID แทน
               </p>
            </div>
            <ActionItems />
         </div>
      </Modal>
   );
};

export default AdobeChangeModal;
